import { render } from "./PasswordUser.vue?vue&type=template&id=7946f636"
import script from "./PasswordUser.vue?vue&type=script&lang=js"
export * from "./PasswordUser.vue?vue&type=script&lang=js"

import "./PasswordUser.vue?vue&type=style&index=0&id=7946f636&lang=css"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "7946f636"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7946f636', script)) {
    api.reload('7946f636', script)
  }
  
  module.hot.accept("./PasswordUser.vue?vue&type=template&id=7946f636", () => {
    api.rerender('7946f636', render)
  })

}

script.__file = "src/components/PasswordUser.vue"

export default script